import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { KeepProvider } from "./lib/keep";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <KeepProvider>
      <App />
    </KeepProvider>
  </StrictMode>,
);
